import { render, staticRenderFns } from "./recordingRemoveConfirmModal.vue?vue&type=template&id=6b1ba813&"
import script from "./recordingRemoveConfirmModal.vue?vue&type=script&lang=js&"
export * from "./recordingRemoveConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports